import React from 'react';
import { Sun, Moon, Monitor } from 'lucide-react';
import { useTheme } from '../context/ThemeContext';

/**
 * Compact icon button that cycles through theme modes: Auto → Light → Dark → Auto.
 * The icon reflects the *current mode* (not the effective theme).
 */
export const ThemeToggle = ({ className = '' }) => {
  const { mode, cycleMode } = useTheme();

  const Icon = mode === 'auto' ? Monitor : mode === 'light' ? Sun : Moon;
  const label =
    mode === 'auto' ? 'Auto (follows system)' :
    mode === 'light' ? 'Light mode' :
    'Dark mode';

  return (
    <button
      type="button"
      onClick={cycleMode}
      aria-label={`Theme: ${label}. Click to change.`}
      title={`Theme: ${label}. Click to change.`}
      data-testid="theme-toggle"
      className={
        `inline-flex items-center justify-center w-9 h-9 rounded-full ` +
        `text-gray-700 hover:text-black hover:bg-gray-100 ` +
        `dark:text-neutral-300 dark:hover:text-white dark:hover:bg-neutral-800 ` +
        `transition-colors ${className}`
      }
    >
      <Icon size={18} />
    </button>
  );
};

export default ThemeToggle;
